
import * as actions from '../navigation-action/navigation.action';
import { NavigationState, NavigationRecordState } from '../navigation-store/navigation.state';
import { NavigationListResponseModel } from '../navigation-model/navigation-list-response.model';

export const initialState: NavigationState = new NavigationRecordState() as unknown as NavigationState;

export function reducer(
    state = initialState,
    { type, payload }: any
): NavigationState {
    if (!type) {
        return state;
    }
    switch (type) {

        // <--------------- NAVIGATION LIST ---------------> //

        case actions.ActionTypes.DO_NAVIGATION_LIST: {
            return Object.assign({}, state, {
                navigationListLoaded: true,
                navigationListFailed: false,
                navigationListLoading: false
            });
        }

        case actions.ActionTypes.DO_NAVIGATION_LIST_SUCCESS: {
            const navigationListModel = payload.data.map(_navigationlistModel => {
                const tempnavigationListModel = new NavigationListResponseModel(
                    _navigationlistModel
                );
                return tempnavigationListModel;
            });
            return Object.assign({}, state, {
                navigationListLoaded: true,
                navigationListFailed: false,
                navigationListLoading: false,
                navigationList: navigationListModel
            });
        }

        case actions.ActionTypes.DO_NAVIGATION_LIST_FAIL: {
            return Object.assign({}, state, {
                navigationListLoaded: false,
                navigationListFailed: true,
                navigationListLoading: false
            });
        }

        // <---------------UPDATE Navigation LIST ---------------> //


        case actions.ActionTypes.DO_UPDATE_NAVIGATION_LIST_ACTION: {
            return Object.assign({}, state, {
                navigationListUpdateLoading: true,
                navigationListUpdateLoaded: false,
                navigationListUpdateFailed: false
            });
        }
        case actions.ActionTypes.DO_UPDATE_NAVIGATION_LIST_SUCCESS: {
            return Object.assign({}, state, {
                navigationListUpdateLoaded: true,
                navigationListUpdateFailed: false,
                navigationListUpdateLoading: false,
                updateNavigationList: payload
            });
        }
        case actions.ActionTypes.DO_UPDATE_NAVIGATION_LIST_FAIL: {
            return Object.assign({}, state, {
                navigationListUpdateLoaded: false,
                navigationListUpdateFailed: true,
                navigationListUpdateLoading: false,
                updateNavigationList: payload
            });
        }

        default: {
            return state;
        }
    }
}

export const getNavigationListLoaded = (state: NavigationState) =>
    state.navigationListLoaded;
export const getNavigationListFailed = (state: NavigationState) =>
    state.navigationListFailed;
export const getNavigationListLoading = (state: NavigationState) =>
    state.navigationListLoading;
export const getNavigationList = (state: NavigationState) => state.navigationList;
export const getUpdatedNavigationList = (state: NavigationState) => state.updateNavigationList;
export const getUpdatedNavigationListLoaded = (state: NavigationState) =>
    state.navigationListUpdateLoaded;
export const getUpdatedNavigationListFailed = (state: NavigationState) =>
    state.navigationListUpdateFailed;
export const getUpdatedNavigationListLoading = (state: NavigationState) =>
    state.navigationListLoading;




